<template>
  <div class="d-flex flex-column justify-content-between h-100">
    <div>
      <draggable v-model="chapterList" group="people" @start="drag=true" @end="drag=false">
        <BRow v-for="chapter in chapterList" :key="chapter.id">
          <BCol cols="8" class="position-relative">
            <BButton
                v-show="(!editChapter && currentChapter.id === chapter.id) || currentChapter.id !== chapter.id"
                @click="selectChapter(chapter.id)"
                :class="currentChapter.id === chapter.id ? 'chapter--active' : null"
                class="chapter p-3 shadow-none border-0"
                block
            >
              <span v-if="currentChapter.id !== chapter.id">{{ chapter.name }}</span>
              <span v-if="currentChapter.id === chapter.id">{{ chapterName }}</span>

            </BButton>
            <span
                class="mdi edit-chapter"
                :class="{'mdi-check': editChapter, 'mdi-pencil': !editChapter}"
                v-if="currentChapter.id === chapter.id"
                @click="editHeader(chapter.id, chapter.name)"
            />
            <BRow v-if="currentChapter.id === chapter.id" v-show="editChapter">
              <BCol cols="12">
                <BFormGroup>
                  <BInput
                      v-model="chapterTitle"
                      id="chapter-name"
                      class="shadow-none"
                  />
                </BFormGroup>
              </BCol>
            </BRow>
          </BCol>
          <BCol cols="2" class="p-2 text-center">
            <BButton variant="link" @click="toDeleteChapter(chapter.id)">
              <i class="mdi mdi-trash-can"></i>
            </BButton>
          </BCol>
          <BCol cols="2" class="p-3 text-center">
              <span
                  :class="chapter.link ? 'chapter--with-audio' : null"
                  class="text-white"
              >
                <font-awesome-icon icon="music" />
              </span>
          </BCol>
        </BRow>
      </draggable>
    </div>
    <BRow>
      <BCol class="text-center">
        <div class="add-chapter-button__outer rounded-circle d-inline-block">
          <BButton @click="addNewChapter" class="mb-3 rounded-circle add-chapter-button position-absolute">
            <font-awesome-icon
                icon="plus"
                size="2x"
            />
          </BButton>
        </div>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import * as chapterActions from "../../../store/modules/Chapter/types/actions";
import * as chapterGetters from "../../../store/modules/Chapter/types/getters";
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";
import VueMce from 'vue-mce';

export default {
  name: "ChapterList",
  components: {
    draggable
  },
  data: () => ({
    editChapter: false,
    chapterTitle: "",
    chapterName: "",
  }),
  computed: {
    chapterList: {
      get() {
        return _.sortBy(_.values(this.$store.state.Chapter.chapters), 'index');
      },
      set(chapterList) {
        this.mixChapters({chapterList: chapterList});
      }
    },
    ...mapGetters('Chapter', {
      currentChapter: chapterGetters.GET_CHAPTER
    })
  },
  watch: {
    currentChapter(value) {
      this.chapterName = value.name;
    }
  },
  methods: {
    ...mapActions('Chapter', {
      getChapterById: chapterActions.GET_CHAPTER,
      addChapter: chapterActions.ADD_CHAPTER,
      mixChapters: chapterActions.MIX_CHAPTERS,
      deleteChapter: chapterActions.DELETE_CHAPTER,
      updateChapterName: chapterActions.UPDATE_CHAPTER_NAME,
      updateChapter: chapterActions.UPDATE_CHAPTER
    }),
    setNotification(variant, message) {
      Swal.fire(
          message,
          '',
          variant
      )
    },
    async editHeader(id, title) {
      if (this.editChapter) {
        console.log("Need update chapter title", this.chapterTitle);
        console.log("Current chapter", this.currentChapter);
        try {
          this.updateChapterName({id:this.currentChapter.id, name: this.chapterTitle})
              .then(
                  this.setNotification('success', 'Назва успішно збережена')
              );
        } catch (err) {
          console.log(err);
        }
        this.chapterName = this.chapterTitle;
      } else {
        this.chapterTitle = title;
      }
      this.editChapter = !this.editChapter;
    },
    async addNewChapter() {
      let newChapterId = await this.addChapter({
        audioBookId: this.$route.params.id
      })
      await this.selectChapter(newChapterId.id);
    },
    toDeleteChapter(chapterId) {
        this.deleteChapter(chapterId);
    },
    async selectChapter(chapterId) {
      this.editChapter = false;
      await this.getChapterById(chapterId);
      this.$emit('selectedChapter');
    }
  }
}
</script>
<style scoped>
.edit-chapter {
  position: absolute;
  right: -14px;
  top: 15px;
  z-index: 999;
  cursor: pointer;
}
.add-chapter-button__outer {
  width: 100px;
  height: 100px;
  background: rgba(248, 248, 248, 1);
  box-shadow: -10px -10px 20px 0px rgba(255, 255, 255, 1) inset,
        10px 10px 10px 0px rgba(0, 0, 0, 0.05),
        -10px -10px 15px 0px rgba(255, 255, 255, 1),
        10px 10px 10px 0px rgba(0, 0, 0, 0.05) inset;
}
.add-chapter-button {
  top: 13px;
  left: 50%;
  width: 75px;
  height: 75px;
  border: none;
  transform: translateX(-50%);
  background: linear-gradient(159.16deg, #21A28E 26.46%, #2D622F 116.55%);
  box-shadow: 10px 10px 15px 0px rgba(255, 255, 255, 0.2) inset,
              0px 5px 10px 0px rgba(55, 46, 152, 0.65);
}

.chapter {
  color: #000000;
  background: transparent;
}
.chapter--active {
  color: #FFFFFF;
  background: #8E8AD3;
}
.chapter__move-button {
  color: #E5E5E5;
}
.chapter__move-button--active {
  color: #8E8AD3;
}
.chapter--with-audio {
  color: #FB9A99 !important;
}
</style>
